import { Box, Grid, Typography } from "@mui/material"
import KeyIcon from '@mui/icons-material/Key';

import { DlspTable } from "./DlspTable"
import { safeFormatDate } from "../../../utils/utilityFunctions"


export function FieldQADetails({desktopQABy, desktopQAOwner, desktopQADate, fieldQA}) {
    const leftTableRows = []
    leftTableRows.push({label: 'Field QA Complete', text: fieldQA?.fieldQAComplete})
    leftTableRows.push({label: 'Field QA Comments', text: fieldQA?.fieldQAComments})
    if (fieldQA?.nextStatus === 'Field') {
        const landOwnerLabel = <><KeyIcon /><br /><span>Land Owner Permission Required</span></>
        leftTableRows.push({label: 'Field Inspection Photos Required', text: fieldQA?.fieldPhotosRequired})
        leftTableRows.push({label: landOwnerLabel,   text: fieldQA?.landOwnerPermissionRequired})
    }
    if (fieldQA?.nextStatus === 'Remedial') {
        leftTableRows.push({label: "Remedial Work Priority",   text: fieldQA?.remedialPriority})
    }


    const rightTableRows = []
    rightTableRows.push({label: 'Next Status', text: fieldQA?.nextStatus})

    return (
        <Box sx={{my: 2}}>
            {/* <Box>
                <Typography variant="body2">Owner: {fieldQAOwner}</Typography>
            </Box> */}
            {
            (desktopQABy && desktopQADate && fieldQA)
            &&
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body2"><strong>{desktopQAOwner}</strong></Typography>
                    <Typography variant="body2"><strong>{safeFormatDate(desktopQADate, 'd MMMM yyyy HH:mm a')}</strong></Typography>

                </Grid>
                <Grid item md={6}>
                    <DlspTable rows={leftTableRows} skipHeader={true} />
                </Grid>
                <Grid item md={6}>
                    <DlspTable rows={rightTableRows} skipHeader={true} />
                </Grid>
            </Grid>
            }
        </Box>
    )
}